// ----------------------------------------------------------------------------
// Component: Page Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block'; //if using page-header--video

// Styles
import './_page-header.scss';
